const partner = resolve => require(['@/pages/partner/index'], resolve);
const partnerAudit = resolve => require(['@/pages/partner/audit/index'], resolve);
const partnerGroup = resolve => require(['@/pages/partner/group/index'], resolve);
const orderExtendedDetail = resolve => require(['@/pages/partner/group/orderExtendedDetail'], resolve);



export default [
  /*****************合伙人管理*******************/
  {
    path: "/partner",
    name: "合伙人管理",
    component: partner,
    meta: {
        keepAlive: true
    }
  },
  {
    path: "/partnerAudit",
    name: "合伙人审核",
    component: partnerAudit,
    meta: {
        keepAlive: true
    }
  },
  {
    path: "/partner/group/:type/:id/:memberId",
    name: "合伙人详情",
    component: partnerGroup,
    meta: {
        keepAlive: true
    }
  },
  {
    path: "/partner/orderExtendedDetail",
    name: "拓展订单明细",
    component: orderExtendedDetail
  },
 
]
